export default __webpack_public_path__ + "static/poster-d41a64b84da6e78a5830f6931722c1a3.png";